import styles from './MobileDatenschutzScreen.module.scss'
import { ReactElement } from 'react'
import { MobileBodyLarge, MobileHeadlineLarge, MobileTitleLarge } from '../../Typography'

export const MobileDatenschutzScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <MobileHeadlineLarge>Datenschutz</MobileHeadlineLarge>
      <MobileTitleLarge>Datenschutzerklärung für eingebettete YouTube-Videos</MobileTitleLarge>
      <MobileBodyLarge fontWeight={700}>1. Einleitung</MobileBodyLarge>
      <MobileBodyLarge>
        Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer persönlichen Daten
        ist uns ein besonderes Anliegen. In dieser Datenschutzerklärung informieren wir Sie darüber,
        welche Daten erhoben werden, wenn Sie unsere Website besuchen und eingebettete
        YouTube-Videos nutzen.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>2. Einbindung von YouTube-Videos</MobileBodyLarge>
      <MobileBodyLarge>
        Unsere Website verwendet eingebettete Videos von YouTube, einem Dienst der Google Ireland
        Limited (Gordon House, Barrow Street, Dublin 4, Irland). Beim Abspielen eines eingebetteten
        Videos werden Daten an YouTube übertragen.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>3. Welche Daten werden erfasst?</MobileBodyLarge>
      <MobileBodyLarge>
        Wenn Sie eine Seite mit einem eingebetteten YouTube-Video aufrufen, kann YouTube unter
        anderem folgende Daten erfassen:
      </MobileBodyLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>{' \u2022 '}Ihre IP-Adresse</MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Informationen über den verwendeten Browser und das Betriebssystem
        </MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Besuchte Webseiten und Interaktionen mit dem Video
        </MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Falls Sie bei YouTube oder Google eingeloggt sind, kann Ihr Nutzungsverhalten
          Ihrem Profil zugeordnet werden.
        </MobileBodyLarge>
      </div>
      <MobileBodyLarge fontWeight={700}>4. Rechtsgrundlage der Datenverarbeitung</MobileBodyLarge>
      <MobileBodyLarge>
        Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse), da wir ein berechtigtes Interesse an der nutzerfreundlichen
        Einbindung von Videos haben. Falls Sie in die Nutzung von Cookies und Tracking durch YouTube
        einwilligen, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO
        (Einwilligung).
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>
        5. Verwendung des erweiterten Datenschutzmodus
      </MobileBodyLarge>
      <MobileBodyLarge>
        Soweit möglich, nutzen wir den erweiterten Datenschutzmodus von YouTube. Dadurch werden
        weniger Daten an YouTube übertragen, insbesondere solange Sie das Video nicht aktiv
        abspielen. Sobald Sie das Video starten, können jedoch weitere Daten durch YouTube erfasst
        werden.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>6. Cookies und Tracking durch YouTube</MobileBodyLarge>
      <MobileBodyLarge>
        YouTube kann Cookies und Tracking-Technologien einsetzen. Dies kann dazu führen, dass Ihr
        Nutzungsverhalten analysiert wird. Sie können dies durch entsprechende Einstellungen in
        Ihrem Google-Konto oder durch die Nutzung von Browser-Erweiterungen einschränken.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>7. Datenweitergabe und Speicherdauer</MobileBodyLarge>
      <MobileBodyLarge>
        YouTube kann erhobene Daten an Google-Server in den USA übermitteln. Google verpflichtet
        sich zur Einhaltung der EU-Standardvertragsklauseln zum Schutz personenbezogener Daten. Die
        Speicherdauer hängt von den Richtlinien von Google ab.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>8. Ihre Rechte</MobileBodyLarge>
      <MobileBodyLarge>Sie haben das Recht auf:</MobileBodyLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>
          {' \u2022 '}Auskunft über die gespeicherten Daten (Art. 15 DSGVO)
        </MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Berichtigung unrichtiger Daten (Art. 16 DSGVO)
        </MobileBodyLarge>
        <MobileBodyLarge>{' \u2022 '}Löschung Ihrer Daten (Art. 17 DSGVO)</MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Einschränkung der Verarbeitung (Art. 18 DSGVO)
        </MobileBodyLarge>
        <MobileBodyLarge>
          {' \u2022 '}Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)
        </MobileBodyLarge>
        <MobileBodyLarge>{' \u2022 '}Datenübertragbarkeit (Art. 20 DSGVO)</MobileBodyLarge>
      </div>
      <MobileBodyLarge>
        Bitte wenden Sie sich an uns, falls Sie Ihre Rechte geltend machen möchten.
      </MobileBodyLarge>
      <MobileBodyLarge fontWeight={700}>9. Kontakt</MobileBodyLarge>
      <MobileBodyLarge>
        Falls Sie Fragen zum Datenschutz auf unserer Website haben, kontaktieren Sie uns bitte
        unter:
      </MobileBodyLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>FIGHTBACK Wrestling</MobileBodyLarge>
        <MobileBodyLarge>c/o German Hurricane Wrestling e. V.</MobileBodyLarge>
        <MobileBodyLarge>Goethestraße 13A</MobileBodyLarge>
        <MobileBodyLarge>64569 Nauheim</MobileBodyLarge>
        <MobileBodyLarge>+49 176 32646683</MobileBodyLarge>
        <MobileBodyLarge>office@fightback-wrestling.com</MobileBodyLarge>
      </div>
      <MobileBodyLarge fontWeight={700}>10. Änderungen dieser Datenschutzerklärung</MobileBodyLarge>
      <MobileBodyLarge>
        Wir behalten uns das Recht vor, diese Datenschutzerklärung anzupassen, falls sich
        gesetzliche oder technische Änderungen ergeben. Die jeweils aktuelle Version finden Sie auf
        unserer Website.
      </MobileBodyLarge>
      <MobileBodyLarge fontStyle={'italic'}>Stand: 29.03.2025</MobileBodyLarge>
    </div>
  )
}
